const navs = {
  'dashboard': {
    name: 'exchange-nav-dashboard',
    url: '/usercenter/dashboard/overview',
    children: [],
  },
  'wallet': {
    name: 'exchange-nav-wallet',
    url: '/usercenter/wallet/balances',
    children: [
      { url: '/usercenter/wallet/balances', name: 'exchange-nav-balances' },
      {
        url: '/usercenter/wallet/deposit/BTC',
        name: 'exchange-nav-deposit',
        validator: ({ subUser }) => !subUser,
      },
      {
        url: '/usercenter/wallet/withdrawals/BTC',
        name: 'exchange-nav-withdraw',
        validator: ({ subUser }) => !subUser,
      },
      {
        url: '/usercenter/wallet/money-log',
        name: 'exchange-nav-depositWithdrawHistory',
        validator: ({ subUser }) => !subUser,
      },
      { url: '/usercenter/wallet/distribution-history', name: 'exchange-nav-distributionHistory' },
    ],
  },
  'history': {
    name: 'exchange-nav-orders',
    url: '/usercenter/history/open-order',
    children: [
      { url: '/usercenter/history/open-order', name: 'exchange-nav-openOrder' },
      { url: '/usercenter/history/trade-order', name: 'exchange-nav-orderHistory' },
      { url: '/usercenter/history/user-trade', name: 'exchange-nav-tradeHistory' },
    ],
  },
  'margin-orders': {
    name: 'exchange-nav-marginOrders',
    url: '/usercenter/margin-orders/open-order',
    children: [
      { url: '/usercenter/margin-orders/open-order', name: 'exchange-nav-openOrder' },
      { url: '/usercenter/margin-orders/trade-order', name: 'exchange-nav-orderHistory' },
      { url: '/usercenter/margin-orders/user-trade', name: 'exchange-nav-tradeHistory' },
      { url: '/usercenter/margin-orders/borrow', name: 'exchange-nav-borrowing' },
      { url: '/usercenter/margin-orders/repayment', name: 'exchange-nav-repayment' },
      { url: '/usercenter/margin-orders/transfer', name: 'exchange-nav-rransfers' },
      { url: '/usercenter/margin-orders/interest', name: 'exchange-nav-interest' },
      { url: '/usercenter/margin-orders/margin-call', name: 'exchange-nav-marginCalls' },
    ],
    validator: ({ isExistMarginAccount }, enableMargin) => enableMargin && isExistMarginAccount,
  },
  'settings': {
    name: 'exchange-nav-settings',
    url: '/usercenter/settings/profile',
    children: [
      { url: '/usercenter/settings/profile', name: 'exchange-nav-profile' },
      { url: '/usercenter/settings/api-management', name: 'exchange-nav-APIManagement' },
    ],
  },
  'security': {
    name: 'exchange-nav-security',
    url: '/usercenter/security',
    children: [],
  },
  'subAccount': {
    name: 'exchange-nav-subAccounts',
    url: '/usercenter/sub-account',
    children: [
      // { url: '/usercenter/sub-account/account-management', name: 'exchange-nav-accountManagement' },
      // { url: '/usercenter/sub-account/asset-management', name: 'exchange-nav-AssetManagement' },
      // { url: '/usercenter/sub-account/orders-management', name: 'exchange-nav-orderManagement' },
      // { url: '/usercenter/sub-account/transfer-history', name: 'exchange-nav-transferHistory' },
      // { url: '/usercenter/sub-account/login-history', name: 'exchange-nav-loginHistory' },
    ],
    validator: ({ isParentUser }) => isParentUser,
  },
};

export default navs;
